import React, { createContext, useContext, useState } from "react";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [activeRequests, setActiveRequests] = useState(0);

  const setLoading = (isLoading) => {
    setActiveRequests((prev) => (isLoading ? prev + 1 : Math.max(prev - 1, 0)));
  };

  const instance = { loading: activeRequests > 0, setLoading };
  setLoadingInstance(instance);

  return (
    <LoadingContext.Provider value={instance}>
      {children}
    </LoadingContext.Provider>
  );
};

// Custom Hook for Components
export const useLoading = () => useContext(LoadingContext);

// Function for Non-Component Usage (Like `ApiMethods.js`)
let loadingInstance = null;
export const getLoadingInstance = () => loadingInstance;

export const setLoadingInstance = (instance) => {
  loadingInstance = instance;
};
